export default {
  appointment: {
    setupDate: '',
    disconnectDate: '',
  },
  moveServiceInfo: { firstName: '' },
  orderDetailsView: {},
  orderNo: '',
  confirmation: {},
  errorInfo: {
    status: false,
    msg: '',
  },
  suspendInfo: {
    status: false,
    msg: '',
  },
  allPlansDetails: {},
  plans: {},
  planDetails: {},
  comparePlan: {
    planDetails: null,
    errorInfo: {
      status: false,
      msg: '',
    },
  },
  getAvailablePlansError: '',
  estimatedBillSummary: {},
  importantAccountChanges: {},
  agreement: {
    agreementDetails: null,
    errorInfo: {
      status: false,
      msg: '',
    },
  },
  mtn: '',
};
